import SunnyShy from "../assets/sunny-shy.svg?react"
import styles from "./PortraitOnly.module.scss"
import typography from "@rawa/ui/styles/typography.module.css"
import cx from "clsx"

export function PortraitOnly() {
  return (
    <div className={styles.overlay} aria-hidden="true">
      <SunnyShy className={styles.sunny} aria-hidden={true} />
      <p className={cx(typography.bodyLarge, styles.message)}>
        Please rotate your device to portrait mode
      </p>
    </div>
  )
}
